
import React, { Component } from 'react'
import Player from './Player'
import './PlayerController.css'

class PlayerController extends Component {

    constructor(props) {
        super(props)
        this.state = {
            player1VideoId: null,
            player2VideoId: null,
            player1ZIndex: { zIndex: 1 },
            player2ZIndex: { zIndex: 0 },
            players: [],
            playerIndex: 0
        }
        this.next = { meanVolume: -15 }
        this.device = this.props.device
        this.playersCount = 2
        if (this.isMobile()) {
            this.playersCount = 1
        }
        for (let i = 0; i < this.playersCount; i++) {
            this.state.players.push({
                ad: { videoId: null },
                id: i,
                zIndex: { zIndex: 0 }
            })
        }
    }

    isMobile = function () {
        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    startNextVideo = (ad) => {
        this.resetAudioVote(ad, this.wasVoted)
        this.setState((prevState) => {
            let nextIndex = prevState.playerIndex + 1
            if (nextIndex >= this.state.players.length) {
                nextIndex = 0
            }
            prevState.players[nextIndex].ad = ad
            return { playerIndex: nextIndex }
        })
    }

    componentDidMount = () => {
        this.playerAboutToComplete(true)
        this.findVotedSongs()
    }

    sortVotedSongsFn = (first, second) => {
        let firstDate = new Date(first.date)
        let secondDate = new Date(second.date)
        if (first.votes === second.votes) {
            if (firstDate < secondDate) {
                return -1
            } else if (firstDate === secondDate) {
                return 0
            } else {
                return 1
            }
        } else if (first.votes > second.votes) {
            return -1
        } else {
            return 1
        }
    }

    getNext = () => {
        if (!this.votedItems || this.votedItems.length === 0) {
            let result = this.device.toReproduce.shift()
            this.device.toReproduce.push(result)
            this.wasVoted = false
            return result
        } else {
            this.votedItems = this.votedItems.sort(this.sortVotedSongsFn)
            this.wasVoted = true
            let votedItem = this.votedItems.shift()
            let song = this.device.toReproduce.find((song) => votedItem.trackId === song.id)
            if (!song) {
                votedItem.videoId = votedItem.youtubeId
                votedItem.meanVolume = votedItem.meanVolume
                votedItem.songImage = votedItem.externalImageUrl
                votedItem.id = votedItem.trackId
                votedItem.startSeconds = votedItem.musicStarts
                votedItem.endSeconds = votedItem.musicEnds
                votedItem.accessCode = this.device.accessCode
                return votedItem
            }
            return song
        }
    }

    onPlay = (index) => {
        setTimeout(this.changeFocus, 5000)
    }

    startNext = async () => {
        if (this.device && this.device.toReproduce) {
            try {
                let request = await fetch(`https://papirodev.appspot.com/_ah/api/api/v2/devices/music/${this.device.code}/voted?serviceKey=test`, { method: 'post' })
                let result = await request.json()
                if (result.items) {
                    this.votedItems = result.items
                }
            } catch (ex) {
                console.log(`Unable to find voted songs at this moment`)
            }
            this.next = this.getNext()
            this.startNextVideo(this.next)
        }
    }

    resetAudioVote = async (ad, wasVoted) => {
        let request = await fetch(`https://papirodev.appspot.com/_ah/api/api/v2/devices/reset-votes/${this.device.code}/${ad.id}?playlist=&serviceKey=test&wasVoted=${wasVoted}`, { method: 'post' })
        let result = await request.json()
        if (result.code !== 200) {
            setTimeout(() => { this.resetAudioVote(ad, wasVoted) }, 20000);
        }
    }

    findVotedSongs = async () => {
        if (!this.wasVoted) {
            let request = await fetch(`https://papirodev.appspot.com/_ah/api/api/v2/devices/music/${this.device.code}/voted?serviceKey=test`, { method: 'post' })
            let result = await request.json()
            if (result.items && result.items.length > 0) {
                this.votedItems = result.items
                if(!this.wasVoted) {
                    this.changeNextVideo(true);
                }
            }
        }
        setTimeout(this.findVotedSongs, 10000)
    }

    changeNextVideo = async (forceStart, delayFocus) => {
        if (this.state.players.length < 2 || forceStart) {
            await this.startNext()
        }
        if (delayFocus) {
            setTimeout(this.changeFocus, 2000)
        } else {
            this.changeFocus()
        }
    }

    onError = () => {
        this.changeNextVideo(true, false)
    }

    onEnd = () => {
        this.changeNextVideo(false, false)
    }

    changeFocus = () => {
        this.setState((prevState) => {
            let players = prevState.players.map((player, index) => {
                if (prevState.playerIndex === index) {
                    player.zIndex = { zIndex: 1 }
                    player.ad = this.next
                } else {
                    player.zIndex = { zIndex: 0 }
                    player.ad = { videoId: null }
                }
                return player
            })
            return { players: players }
        })
    }

    playerAboutToComplete = (firstTime) => {
        if (this.state.players.length > 1 || true) {
            this.startNext()
        }
    }

    render = () => {
        return (
            <div>
                <div className="player-logo" >
                    <img id="logo" src={this.props.device.mainImageDownloadUrl} alt="Logos..." />
                </div>
                {this.state.players.map((player, index) =>
                    <div key={player.id} className="youtube-player" style={player.zIndex}>
                        <Player className="youtube-player"
                            ad={player.ad}
                            width={this.props.width}
                            height={this.props.height}
                            aboutToComplete={() => this.playerAboutToComplete()}
                            onError={() => this.onError()}
                            onEnd={() => this.onEnd()}
                            onPlay={() => this.onPlay(index)} />
                    </div>)}
                {this.next &&
                    <div id="popup-ad">
                        <div id="popup-container">
                            <table id="song-info-table">
                                <tbody>
                                    <tr>
                                        <td id="left-padding">
                                        </td>
                                        <td id="info-image">
                                            {this.next && this.next.songImage && <img id="image" src={this.next.songImage} alt="Album" />}
                                        </td>
                                        <td id="info">
                                            <div id="info-artist">
                                                <div id="info-artist-container">
                                                    <span id="artist">{this.next.artist}</span>
                                                </div>
                                            </div>
                                            <div id="info-artist-title">
                                                <span id="title">{this.next.title}</span>
                                            </div>
                                        </td>
                                        <td id="information-section">
                                            <div id="container-use-ponmusica">
                                                <div id="container-use-ponmusica-title">
                                                    <div>
                                                        Elige en ponmusica.com
                                            </div>
                                                </div>
                                                <div id="container-use-ponmusica-code">
                                                    <span>Código:</span>
                                                    <span id="txt-code">&nbsp; {this.next.accessCode}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td id="right-padding">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>}
            </div>
        );
    }
}

export default PlayerController


// WEBPACK FOOTER //
// ./src/components/player/PlayerController.js